<template>
    <v-dialog v-model="dialog" width="700" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="so_number"
                                :rules="[formRules.required]"
                                label="SO Number"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :readonly="action === 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="unit"
                                :rules="[formRules.required]"
                                label="Unit"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                :readonly="action === 'view'"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input
                                v-model="file"
                                accept="application/pdf"
                                label="Files Attachment (Required, PDF only)"
                                type="file"
                                clearable
                                show-size
                                chips
                                rounded="lg"
                                scrim="darkGreen"
                                variant="outlined"
                                prepend-inner-icon="mdi-file"
                                prepend-icon=""
                                v-if="action != 'view'"
                            />
                        </v-col>
                        <v-col cols="12" v-if="action === 'edit' || action === 'view' && filesList && filesList.length > 0">
                            <span class="font-weight-bold">Attachments:</span>
                            <v-card v-for="file in filesList" :key="file" class="my-2" elevation="2">
                                <v-card-text>
                                    <a @click="showViewFileDialog(file)" style="color: #1a5b0f; text-decoration: underline; cursor: pointer;">
                                        {{ file }}
                                    </a>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col v-if="filesList && filesList.length == 0" cols="12" class="mb-4">
                            <v-card elevation="2">
                                <v-card-text>
                                    No files are attached to this special deloading.
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="description"
                                :rules="[formRules.required]"
                                label="Description"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :readonly="action === 'view'"
                                >
                            </v-textarea>
                        </v-col>
                        <!-- <v-date-input
                            v-model="effective_date"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            :rules="[formRules.required]"
                            variant="outlined"
                            rounded="lg"
                            type="text"
                            color="darkGreen"
                            label="Effective Date"
                        ></v-date-input> -->
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn v-if="action !== 'view'" class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <ViewFileDialog ref="ViewFileDialog"/>
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import ViewFileDialog from './Sub-Dialogs/ViewFileDialog.vue';

export default defineComponent({
    emits: ["refresh"],
    components: {
        ViewFileDialog
    },
    data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            so_number: null,
            description: null,
            unit: null,
            user_id: null,
            semester_schoolyear: null,
            file: null,
            filesList: [],
        }
     },
     methods: {
        initAdd(data){
            this.dialog = true
            this.dialog_title = 'Special Deloading'
            this.dialog_sub_title = 'Add new special deloading'
            this.action = 'add'

            this.user_id = data.id
            this.semester_schoolyear = this.$store.state.semester_schoolyear.id
            this.file = null
            this.filesList = []
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Special Deloading'
            this.dialog_sub_title = 'Update special deloading details'
            this.action = 'edit'

            this.id = data.id
            this.user_id = data.user_id
            this.semester_schoolyear = data.semester_schoolyear
            this.so_number = data.so_number
            this.description = data.description
            this.unit = data.unit
            this.file = null
            this.filesList = data.file ? [data.file] : []
        },
        initView(data){
            this.dialog = true
            this.dialog_title = 'Special Deloading'
            this.dialog_sub_title = 'View special deloading details'
            this.action = 'view'

            this.id = data.id
            this.so_number = data.so_number
            this.description = data.description
            this.unit = data.unit
            this.filesList = data.file ? [data.file] : []
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()
            const selectedFile = Array.isArray(this.file) ? this.file[0] : this.file
            const hasExistingAttachment = Array.isArray(this.filesList) && this.filesList.length > 0
            if (!selectedFile && !hasExistingAttachment) {
                showSnackbar('Please upload attachment files. Special Order Number counter checking required.', 'error')
                return
            }
            if(valid){
                this.loading = true
                const formData = new FormData();
                formData.append('id', this.id);
                formData.append('so_number', this.so_number);
                formData.append('description', this.description);
                formData.append('unit', this.unit);
                formData.append('user_id', this.user_id);
                formData.append('semester_schoolyear', this.semester_schoolyear);
                if(selectedFile){
                    formData.append('file', selectedFile);
                }
                if(this.action == 'add'){
                    let save = await this.axiosCall('/special-deloading', 'post', formData, true)
                    if (save && save.data.status == 200) {
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('Special deloading successfully added!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }
                else if(this.action == 'edit'){
                    let update = await this.axiosCall('/special-deloading/' + this.id, 'patch', formData, true)
                    if (update && update.data.status == 200) {
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('Special deloading successfully updated!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }
            }
        },
        showViewFileDialog(file) {
            this.$refs.ViewFileDialog.viewFile(file);
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>